module.exports = __webpack_public_path__ + "static/img/empty@3x.4546a557.png";